module.exports = __webpack_public_path__ + "img/Symbol_Wild.948327a6.png";